import { useNavigation, useRoute } from '@react-navigation/core'
import * as React from 'react'
import { useEffect } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { EnterOtpComp } from './EnterOtpComp'

export const EnterAadhaarOtpScreen = () => {
  const navigation = useNavigation()
  const { linkAadhharWithOtp, sendOTPToAadhaar } = useStores((root) => ({
    linkAadhharWithOtp: root.customer.linkAadhharWithOtp,
    sendOTPToAadhaar: root.customer.sendOTPToAadhaar,
  }))
  const routes: any = useRoute()

  const mobileNo: any = routes.params?.mobileNo
  const aadhaarNo: any = routes.params?.aadhaarNo
  const [linkAadhharWithOtpApi, linkAadhharHandler] = useLazyApiData(linkAadhharWithOtp)
  const [sendOTPToAadhaarApi, sendOtpHandler] = useLazyApiData(sendOTPToAadhaar, mobileNo)

  const onOtpSubmit = (otp: string) => linkAadhharWithOtpApi(aadhaarNo, mobileNo, otp)

  console.log('onAadhaarCardLinked 4', routes?.params?.onAadhaarCardLinked)
  useEffect(() => {
    if (linkAadhharHandler.state === 'fulfilled') {
      navigation.goBack()
      navigation.goBack()
      navigation.goBack()
      if (routes?.params?.onAadhaarCardLinked) {
        routes?.params?.onAadhaarCardLinked()
      }
    }
  }, [linkAadhharHandler.state, navigation, routes])
  React.useEffect(() => {
    navigation.setOptions({ headerTitle: 'Link Aadhar' })
  }, [navigation])

  return (
    <EnterOtpComp
      onOtpSubmit={onOtpSubmit}
      isLoading={linkAadhharHandler.state === 'pending'}
      title="Please enter your 6-digit AADHAAR OTP"
      subTitle="A 6-digit one time password is sent to your AADHAAR registered mobile number."
      buttonTitle="Verify and Link Aadhaar"
      onResendOTPPress={() => {
        sendOTPToAadhaarApi(aadhaarNo, mobileNo)
      }}
      resendOtpState={sendOtpHandler?.state}
    />
  )
}
